import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBag = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 50,
	height: 95,
	viewBox: "0 0 50.0 95.0",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 25.0 A 25.0 10.0 0.0 1 1 50.0 25.0 L 50.0 95.0 L 0.0 95.0 Z M 25.0 14.0 L 15.0 0.0 L 35.0 0.0 Z M 25.0 0.0 L 25.0 15.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})
});
export default SvgBag;
